import { ClarionButton } from '@clarion/ClarionButton';
import { ClarionMenu, ClarionMenuItem, ClarionMenuSection } from '@clarion/ClarionMenu';
import { MenuTrigger } from 'react-aria-components';
import { useNavigate } from 'react-router';
import { useWorkspaces } from '../../auth/WorkspaceState';
import { formatRoleName } from '../../workspace/permission';
import { useSideNavigation } from './SideNavigationContext';

export function WorkspaceSelector() {
  const { current: workspace, workspaces, currentRole } = useWorkspaces();
  const navigate = useNavigate();
  const { isCollapsed } = useSideNavigation();

  if (workspaces.length < 2) return null;

  return (
    <MenuTrigger>
      <ClarionButton
        variant="minimal"
        size="large"
        fill
        tooltip={isCollapsed ? workspace?.workspaceName || 'Select workspace' : undefined}
        tooltipPlacement="right"
        icon="office"
        textAlign="left"
      >
        {!isCollapsed && (
          <div className="flex-1 min-w-0">
            <div className="truncate text-sm font-medium text-gray-900 dark:text-gray-100">
              {workspace?.workspaceName || 'Select workspace'}
            </div>
            <div className="text-xs opacity-70 capitalize">{currentRole?.replace('-', ' ')}</div>
          </div>
        )}
      </ClarionButton>
      <ClarionMenu
        selectionMode="single"
        selectedKeys={[workspace?.workspaceId || '']}
        onSelectionChange={(keys) => {
          const selectedId = Array.from(keys)[0] as string;
          if (selectedId) navigate(`/workspaces/${selectedId}/files/recap`);
        }}
      >
        <ClarionMenuSection title="Select workspace">
          {workspaces.map((ws) => (
            <ClarionMenuItem
              key={ws.workspace.workspaceId}
              id={ws.workspace.workspaceId}
              textValue={ws.workspace.workspaceName}
            >
              <div>
                <span>{ws.workspace.workspaceName}</span>
                <br />
                <span className="text-xs opacity-70">Role: {formatRoleName(ws.role)}</span>
              </div>
            </ClarionMenuItem>
          ))}
        </ClarionMenuSection>
      </ClarionMenu>
    </MenuTrigger>
  );
}
